<div [innerHTML]="diffHtml | safeHtml" class="text-diff"></div>
